/**
 * directive for collapsible content
 */
angular.module('impactx.displayelements').directive('ixCollapsible', function () {
    return {
        scope: {
            content: '=',
            labelLess: '@',
            labelMore: '@'
        },
        restrict: 'E',
        templateUrl: 'shared/displayelements/templates/collapsible.html',
        transclude: true
    };

});